import request from '@/utils/request'
import store from '../store'

// 生成订单
export function submitOrders (data) {
  return request({
    url: '/ordering_system_mobile/order/submitOrders',
    method: 'post',
    data: {
      userId: store.state.user.userId,
      conferenceId: store.state.user.conferenceId,
      ...data
    }
  })
}

// 添加购物车
export function addcart (data) {
  return request({
    url: '/ordering_system_mobile/conferencecart/addcart',
    method: 'post',
    data: {
      userId: store.state.user.userId,
      conferenceId: store.state.user.conferenceId,
      ...data
    }
  })
}

// 获取用户报名的活动 -- 购物车
export function getConferenceList (data) {
  return request({
    url: '/ordering_system_mobile/conferenceuserinfo/getConferenceList',
    method: 'post',
    data: {
      userId: store.state.user.userId
    }
  })
}

// 购物车列表
export function cartList (data) {
  return request({
    url: '/ordering_system_mobile/conferencecart/cartList',
    method: 'post',
    data: {
      userId: store.state.user.userId,
      // conferenceId: store.state.user.conferenceId,
      num: 5,
      ...data
    }
  })
}

// 购物车修改数量
export function updatecartNum (data) {
  return request({
    url: '/ordering_system_mobile/conferencecart/updatecartNum',
    method: 'post',
    data: {
      userId: store.state.user.userId,
      conferenceId: store.state.user.conferenceId,
      ...data
    }
  })
}

// 删除购物车一件商品
export function delcartitem (data) {
  return request({
    url: '/ordering_system_mobile/conferencecart/delcartitem',
    method: 'post',
    data: {
      userId: store.state.user.userId,
      conferenceId: store.state.user.conferenceId,
      ...data
    }
  })
}

// 获取订单列表
export function getOrdersList (data) {
  return request({
    url: '/ordering_system_mobile/order/getOrdersList',
    method: 'post',
    data: {
      userId: store.state.user.userId,
      conferenceId: store.state.user.conferenceId,
      num: 5,
      ...data
    }
  })
}

// 获取订单详情
export function getOrdersDetail (data) {
  return request({
    url: '/ordering_system_mobile/order/getOrdersDetail',
    method: 'post',
    data: {
      userId: store.state.user.userId,
      conferenceId: store.state.user.conferenceId,
      ...data
    }
  })
}

// 取消订单
export function cancelOrders (data) {
  return request({
    url: '/ordering_system_mobile/order/cancelOrders',
    method: 'post',
    data: {
      userId: store.state.user.userId,
      ...data
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/order.js